<template>
  <section class="container story02">
    <h2 class="bsS02Tit">Lifening</h2>
    <div class="swiper-container slide01">
      <div class="swiper-wrapper slide01--wrapper">
        <div class="swiper-slide slide01--txt">
          <div class="slide01--wrap">
            <p class="slide01--p">
              섬세한 손으로 내 이마를 짚어주는 사람, <br>
              실수한 아이를 따뜻하게 안아주는 사람, <br>
              그 사람에게 어떤 말을 건넸는지 기억나지 않아도  <br>
              그의 빛나는 모습만은 분명하게 내 마음에 자리 잡습니다.
            </p>
            <p class="slide01--p">
              내 비지니스에 힘이 되어주는 사람, <br>
              화가 난 상사에게 차분하고 당당하게 맞서는 사람, <br>
              그 사람에게 어떤 표정을 지었는지 기억나지 않아도  <br>
              그의 빛나는 모습만은 분명하게 내 마음에 자리 잡습니다.
            </p>
            <p class="slide01--p">
              오감에 싱그러운 풍요를 불어넣는 사람, <br>
              갑작스러운 소나기에도 나무를 보며 미소 짓는 사람, <br>
              그 사람에게 어떤 눈길을 주었는지 기억나지 않아도 <br>
              그의 빛나는 모습만은 분명하게 내 마음에 자리 잡습니다.
            </p>
          </div>
        </div>
        <div class="swiper-slide slide01--txt">
          <div class="slide01--wrap">
            <p class="slide01--p">
              a hand upon my forehead <br>
              내 이마를 짚어주는 손
            </p>
            <p class="slide01--p">
              a place to call my own <br>
              내 것이라 부를 수 있는 장소
            </p>
            <p class="slide01--p">
              Just some simple kindness <br>
              그저 약간의 친절
            </p>
            <p class="slide01--p">
              To share what I’ve been given <br>
              내가 타고난 것을 나눌 수 있기를 
            </p>
            <p class="slide01--p">
              This is all I ever wanted from life <br>
              내가 삶에서 원했던 건 단지 이게 전부야
            </p>
            <p class="slide01--p">
              (Snow Patrol - Lifening 노래 가사 中)
            </p>
          </div>
        </div>
        <div class="swiper-slide slide01--txt">
          <div class="slide01--wrap">
            <p class="slide01--p">
              인간은 단지 욕망할 뿐일까요? <br>
              아니요, 차가운 데이터는 인간을 그런 존재로 단순화하지만 <br>
              Lifening은 그렇게 생각하지 않습니다. <br>
              Lifening은 알고 있습니다. 아주 작은 순간의 행복이라도, <br>
              그 가치를 온전히 누리기 위해 필요한 것은 에너지, <br>
              바로 그것이라고.
            </p>
            <p class="slide01--p">
              행복을 찾기 위해 필요한 에너지, <br>
              행복을 누리기 위해 필요한 에너지, <br>
              그 에너지를 만드는 오늘의 선택은 Lifening입니다.
            </p>
            <p class="slide01--p">
              오늘의 Lifening, 에너지 넘치는 내일을 만듭니다. <br>
              오늘의 Lifening, 행복한 내일을 만듭니다.
            </p>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <!-- <div class="story02--con">

      <div class="story02--left col-sm-5 order-2 order-sm-1"></div>
      <div class="story02--right col-sm-7 order-1 order-sm-2"> -->

        <!-- <p class="story02--text">
          내 이마를 짚어주는 사람. <span class="mbr"></span> 그런 사람이 내 곁에 존재한다는 것은​ 축복입니다. <br>
          그 사람에게 오늘 어떤 말을 건넸었나 기억이 나지 않습니다. <br>
          길거리에서 실수한 아이를 다그치지 않고 안아주는 사람을 보았습니다.​ <br>
          그 사람이 빛나 보였습니다.
        </p>
        <p class="story02--text">
          내 업무에 힘을 모아주는 존재.<span class="mbr"></span> 그런 사람을 만나고 헤어지는 일이 반복됩니다. <br>
          그 사람에게 오늘 어떤 표정을 지었었나 기억이 나지 않습니다. <br>
          삿대질을 하는 상사의 화를 받지 않고 명료한 답변으로 한방을 먹이는 사람을 보았습니다. <br>
          그 사람이 빛나 보였습니다.
        </p>
        <p class="story02--text">
          내 업무에 힘을 모아주는 존재.<span class="mbr"></span> 그런 사람을 만나고 헤어지는 일이 반복됩니다. <br>
          그 사람에게 오늘 어떤 표정을 지었었나 기억이 나지 않습니다. <br>
          삿대질을 하는 상사의 화를 받지 않고 명료한 답변으로 한방을 먹이는 사람을 보았습니다. <br>
          그 사람이 빛나 보였습니다.
        </p> -->
        <!-- <p class="story02--text">
          ‘인셀덤 프로젝트’는 수많은 연구와 노력의 결실로 어리고 건강한 세포 본연의 빛을 살려내는 비밀 찾기에 이르렀습니다.<br>
          이 기술을 바탕으로 인셀덤은 저 먼 우주에서 스스로 빛나는 별들처럼 세상에서 가장 아름다운 피부 본연의 빛을 위한 노력을 멈추지 않겠습니다.
        </p>
        <p class="story02--stit">어리고 건강한 세포 발견의 비밀</p> -->
      <!-- </div>
    </div> -->

  </section>
</template>

<script>
import Section from './Section2.vue';

import Swiper from '@/assets/plugins/swiper.min';
import '@/assets/plugins/swiper.min.css';

export default {
  components: { Section },
  name: 'Section2',
  data(){
    return{
      slide01: Swiper,
    }
  },
  mounted() {
    this.slide01 = new Swiper('.slide01', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      speed: 500,
      slidesPerView: 3,
      // height: 600,
      effect: 'slide',
      // loop: true,
      // autoplay: {
        //   delay: 3000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: '.swiper-pagination',
        // type: 'bullets',
      },
      breakpoints: {
        600: {
          slidesPerView: 1,
          // pagination: false,
          // navigation: false,
          height: '100vh',
          // scrollbar: {
          //   el: '.slide1 .btn_controllLR .swiper-scrollbar',
          //   hide: false,
          //   dragSize: 'auto',
          // },
        },
      },
    });
  },
};
</script>

<style lang='scss' scoped>
.brs{
  display: block;
  @media (max-width: 950px) {
    display: none !important;
  }
}
</style>
